enum ComparisonType {
  Absolute = 0,
  GrowthRate = 1,
}

export default ComparisonType;
